// SPDX-License-Identifier: MIT
// Tier config for the mise-en-ligne wizard. Prices are PLACEHOLDERS pending the
// operator's final pricing — never hardcode them into the flow; read from here.
export const TIERS = {
  simple: {
    model: 'genesis-rest' as const,
    titleKey: 'wizard.tier.simple.title',   // "Une base de données"
    descKey: 'wizard.tier.simple.desc',
    cloudPrice: '5 €',
  },
  full: {
    model: 'full-supabase' as const,
    titleKey: 'wizard.tier.full.title',      // "+ Comptes & fichiers"
    descKey: 'wizard.tier.full.desc',
    cloudPrice: '10 €',
  },
} as const;

// Launch (option a): false → both tiers free during the 14-day trial.
// Later (option b): set VITE_FULL_SUPABASE_REQUIRES_CLOUD=true to gate the full
// tier behind Cloud (shown-but-routed-to-upsell, never hidden).
export function fullSupabaseRequiresCloud(): boolean {
  return import.meta.env?.VITE_FULL_SUPABASE_REQUIRES_CLOUD === 'true';
}
